<template>
  <div id="content" class="main-container h-100" :class="{ reverse: reverseSidebar }">
    <div id="sidebar" class="sidebar" :class="{ show: sidebarShow }">
      <div id="toolbar" class="toolbar">
        <div class="row align-items-center h-100 mx-0">
          <div class="col-4">
            <div class="toolbar-time">
              <span>{{ new Date() | moment('h:mm A') }}</span>
            </div>
          </div>

          <div class="col-8 pr-1">
            <div class="d-flex align-items-center justify-content-end">
              <!-- TODO: Show for login last pos -->
              <!-- TODO: Show if isset connect -->
              <div class="toolbar-reverse">
                <a href="#"
                  @click="toggleReverseSidebar">
                  <span class="reverse-btn">
                    <svg class="icon icon-move">
                      <use xlink:href="#icon-move"></use>
                    </svg>
                  </span>
                </a>
              </div>
              <div class="logout">
                <a v-if="posIsConnected"
                  href="#"
                  @click="disconnectPeerConnection"
                  class="logout-btn">
                  <svg class="icon icon-power">
                    <use xlink:href="#icon-power"></use>
                  </svg>
                </a>
              </div>
              <div class='webpos-connect' @click='showKeyModals'>
                <a href='#' class='webpos-btn'>
                  <div
                    :class="{ active : posIsConnected, disabled: posIsConnected === false}"
                    class='icon webpos-icon'>
                    <!-- TODO: add webpos svg icon here -->
                  </div>
                </a>
              </div>

              <div class="toolbar-fullscreen">
                <a href="#"
                  @click="toggleFullscreen">
                  <span class="fullscreen-btn">
                    <svg v-if="!fullscreen"
                        class="icon icon-icon-resize">
                      <use xlink:href="#icon-icon-resize"/>
                    </svg>
                    <svg v-else
                         class="icon icon-icon-unresize">
                      <use xlink:href="#icon-icon-unresize"/>
                    </svg>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex h-100 flex-column">
        <div class="sidebar-top text-center">
          <b-navbar-brand :to="{ name: '/'}">
            <img class="logo" src="../assets/images/svg/logo.svg" alt="">
          </b-navbar-brand>
        </div>

        <div class="sidebar-body mt-auto">
          <table>
            <tr>
              <td>
                Sub Total
              </td>
              <td>
                <strong>
                  <i>
                    {{ orderObject.subtotal >= 0 ? '$'+orderObject.subtotal.toFixed(2) : '- $'+(-1*orderObject.subtotal).toFixed(2) }}
                  </i>
                </strong>
              </td>
            </tr>
            <tr>
              <td>
                Tax
              </td>
              <td>
                <strong>
                  <i>
                    {{ orderObject.tax_total >= 0 ? '$' + orderObject.tax_total.toFixed(2) : '- $' + (-1 * orderObject.tax_total).toFixed(2) }}
                  </i>
                </strong>
              </td>
            </tr>
            <tr>
              <td>
                Discount
              </td>
              <td>
                <strong>
                  <i>
                    {{ orderObject.discount_total > 0 ? '- $'+ orderObject.discount_total.toFixed(2) : '$' + orderObject.discount_total.toFixed(2) }}
                  </i>
                </strong>
              </td>
            </tr>
            <tr v-if="orderObject.surcharge_value && orderObject.surcharge_value > 0 ">
              <td>
                Surcharge
              </td>
              <td>
                <strong>
                  <i>
                    {{  '$' + orderObject.surcharge_value.toFixed(2) }}
                  </i>
                </strong>
              </td>
            </tr>
            <tr>
              <td>
                Total
              </td>
              <td>
                <strong>
                  <i v-if="!orderObject.surcharge_value">
                    {{ orderObject.grand_total >= 0 ? '$' + orderObject.grand_total.toFixed(2) : '- $' + (-1 * orderObject.grand_total).toFixed(2) }}
                  </i>
                  <i v-else>
                    {{ orderObject.grand_total >= 0 ? '$' + (orderObject.grand_total + orderObject.surcharge_value).toFixed(2) : '- $' + (-1 * (orderObject.grand_total + orderObject.surcharge_value)).toFixed(2) }}
                  </i>
                </strong>
              </td>
            </tr>
          </table>
        </div>

        <div class="sidebar-bottom">
          <table>
            <tr>
              <td>
                <strong>
                  <i>
                    Pay
                  </i>
                </strong>
              </td>
              <td>
                <span v-if="!orderObject.surcharge_value" class="price">
                  {{ orderObject.grand_total >= 0 ? '$' + orderObject.grand_total.toFixed(2) : '- $' + (-1 * orderObject.grand_total).toFixed(2) }}
                </span>
                <span v-else class="price">
                  {{ orderObject.grand_total >= 0 ? '$' + (orderObject.grand_total + orderObject.surcharge_value).toFixed(2) : '- $' + (-1 * (orderObject.grand_total + orderObject.surcharge_value)).toFixed(2) }}
                </span>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <div class="sidebar-mask">
      <button @click="sidebarShow = !sidebarShow" :aria-pressed="sidebarShow ? 'true' : 'false'" class="navbar-toggle">
      </button>
    </div>
    <b-navbar class="header" fixed="top" toggleable="sm" type="dark" variant="primary">
      <div class="navbar-top d-flex flex-column justify-content-between h-100">
        <button class="navbar-toggle" @click="sidebarToggle()">
          <svg class="icon icon-icon-menu">
            <use xlink:href="#icon-icon-menu"></use>
          </svg>
        </button>

        <b-navbar-brand :to="{ name: '/'}">
          <img class="logo" src="../assets/images/svg/logo.svg" alt="">
        </b-navbar-brand>
      </div>
    </b-navbar>

    <div class="main-page page">

      <div class="page-top">
        <h2 class="page-title">
          <slot name="page-title"/>
          <slot/>
        </h2>

        <div class="page-meta">
          <slot name="page-meta"/>
          <slot/>
        </div>
      </div>

      <div class="page-body" v-chat-scroll="{always:true,smooth: true}">
        <slot name="page-body"/>
      </div>

    </div>

    <!-- Auth Modal -->
    <!-- <b-button v-b-modal.modal-auth>auth</b-button> -->
    <b-modal
      id="modal-auth"
      modal-class="modal-auth"
      v-model="modalShow"
      :body-bg-variant="bodyBgVariant"
      no-close-on-backdrop
      hide-footer
      title="Please, enter connection details:">
      <div class="pin">
        <b-form @submit="clickOfferPasted(ajaxLoading.show); setLocalStorage(); subscribe(); clearNum()">
          <b-form-group
            id="domain-name"
            label="Domain Name:"
            label-for="input-1"
          >
            <b-form-input
              id="input-1"
              v-model="form.domainName"
              type="text"
              placeholder="Enter domain name"
              required
              @focus="isDomainFocused = true"
              @blur="isDomainFocused = false"
            ></b-form-input>
          </b-form-group>

          <b-form-group id="code" label="Terminal Number:" label-for="input-2">
            <b-form-input
              id="input-2"
              v-model="form.inputCode"
              type="text"
              placeholder="Enter terminal number"
              required
              @focus="isTerminalFocused = true"
              @blur="isTerminalFocused = false"
            ></b-form-input>
          </b-form-group>

          <div class="pin-keyboard text-center">
            <ul class="pin-keyboard-list">
              <li><span @click="typeCode(1)" class="pin-key">1</span></li>
              <li><span @click="typeCode(2)" class="pin-key">2</span></li>
              <li><span @click="typeCode(3)" class="pin-key">3</span></li>

              <li><span @click="typeCode(4)" class="pin-key">4</span></li>
              <li><span @click="typeCode(5)" class="pin-key">5</span></li>
              <li><span @click="typeCode(6)" class="pin-key">6</span></li>

              <li><span @click="typeCode(7)" class="pin-key">7</span></li>
              <li><span @click="typeCode(8)" class="pin-key">8</span></li>
              <li><span @click="typeCode(9)" class="pin-key">9</span></li>

              <li><span @click="clearNum()" class="pin-key pin-key_call">C</span></li>

              <li><span @click="typeCode(0)" class="pin-key">0</span></li>
            </ul>
          </div>

          <b-button
            class="mt-4"
            id="accept"
            type="submit"
            variant="primary"
            block>
            <base-loader :loading='ajaxLoading.show' />
            <span v-if='!ajaxLoading.show'>Accept</span>
            <span v-else class='ml-1'>Cancel</span>
          </b-button>
        </b-form>
      </div>
    </b-modal>

    <!-- Alert Modal -->
    <b-modal
      v-model="alertModal.show"
      :body-bg-variant="bodyBgVariant"
      no-close-on-backdrop
      hide-footer
      :title="alertModal.title"
    >
      <div class='text-center'>{{ alertModal.message }}</div>
      <b-button
        @click="alertModal.show = false"
        variant="primary"
        class='w-100 mt-4'>
        Ok
      </b-button>
    </b-modal>

    <b-modal
      v-model='keyPopupShow'
      :body-bg-variant="bodyBgVariant"
      no-close-on-backdrop
      hide-footer
      title="Connection Key"
    >
        <div class='text-center' v-if='!ajaxLoading.show || connectionKey'>{{ connectionKey }}</div>
        <base-loader :loading='ajaxLoading.show' />
    </b-modal>

    <b-modal
      id="dulpicate-tab-modal"
      v-model="secondaryTab"
      hide-header
      no-close-on-backdrop
      centered
      modal-class="duplicate-tab-popup"
      @ok="useHere()"
    >
      <div>
        <span>Customer Display is open in another window. Click "Use Here" to use Customer Display in this window</span>
      </div>
      <template #modal-footer="{ ok }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button
          size="sm"
          variant="primary"
          @click="ok"
        >
          Use Here
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import rtcConnection from '../mixins/rtcConnection'
import {mapGetters} from 'vuex'
import Pusher from 'pusher-js'
import { setCurrentTab } from '../helpers/activeTabMonitor'

export default {
  name: 'CdLayout',
  components: {},
  mixins: [rtcConnection],
  data () {
    return {
      numList: [],
      sidebarShow: false,
      secondaryTab: false,
      secondaryTabChannel: null,
      modalShow: false,
      bodyBgVariant: 'light',
      alertModal: {
        show: false,
        title: '',
        message: ''
      },
      keyPopupShow: false,
      connectionKey: '',
      ajaxInterval: '',
      pusher: null,
      form: {
        inputCode: '',
        domainName: ''
      },
      isDomainFocused: false,
      isTerminalFocused: false
    }
  },
  computed: {
    ...mapGetters([
      'posIsConnected',
      'reverseSidebar',
      'fullscreen',
      'isSale',
      'sale'
    ]),
    orderObject () {
      return this.$store.getters.order
    }
  },
  watch: {
    orderObject (val) {
      console.log(val)
    },
    webScoketConnection: {
      handler (val) {
        const wasConnected = localStorage.getItem('createdConnection')
        if (val && wasConnected) {
          this.sendMessage('generate')
        }
      },
      immediate: true
    },
    posIsConnected (val) {
      if (val === false) {
        // Connection lost (red status)
        console.log('Connection lost. Waiting for POS to reconnect...')
      } else if (val === true) {
        // Connection restored (green status) - close any error popups
        console.log('Connection restored!')
        this.alertModal.show = false
        this.modalShow = false
      }
    }
  },
  created () {
    // created channel to communicate between two chrome tabs
    this.secondaryTabChannel = new BroadcastChannel('my-channel')
    this.secondaryTabChannel.onmessage = this.handleChannelMessage
    if (this.$workbox) {
      this.$workbox.addEventListener('waiting', () => {
        this.showUpdateUI = true
      })
    }
    setCurrentTab(() => {
      // post message when second tab is detected
      this.secondaryTabChannel.postMessage('second tab')
    })
  },
  mounted () {
    // Load saved connection details from localStorage
    const savedTerminalId = localStorage.getItem('terminalId')
    const savedDomainName = localStorage.getItem('domainName')

    if (savedTerminalId) {
      this.form.inputCode = savedTerminalId
    }
    if (savedDomainName) {
      this.form.domainName = savedDomainName
    }

    // Only show modal if domain or terminal is missing
    if (!savedTerminalId || !savedDomainName) {
      this.modalShow = true
    }

    // pusher initialization
    if (navigator.onLine) {
      console.log('pusher initialized')
      this.subscribe()
    }
  },
  beforeDestroy () {
    if (this.pusher) {
      this.pusher.disconnect()
    }
  },
  methods: {
    subscribe () {
      const terminalId = this.form.inputCode || localStorage.getItem('terminalId')
      const domainName = this.form.domainName || localStorage.getItem('domainName')

      let subscribeChannel = `${domainName}_${terminalId}_channel`
      console.log('subscribeChannel', subscribeChannel)
      this.pusher = new Pusher('33c344d94b71b318f01d', { cluster: 'mt1', debug: true })
      let channel = this.pusher.subscribe(subscribeChannel)
      channel.bind('pusher:subscription_succeeded', () => {
        console.log('Subscription succeeded!')
      })
      channel.bind('cd-event', (data) => {
        console.log('cd-event - POS is ready to connect')
        // Only attempt connection if we have saved credentials and not already connected
        const savedTerminalId = localStorage.getItem('terminalId')
        const savedDomainName = localStorage.getItem('domainName')

        if (savedTerminalId && savedDomainName && !this.posIsConnected) {
          console.log('Auto-connecting to POS...')
          this.clickOfferPasted()
        }
        this.$forceUpdate()
      })
    },
    setLocalStorage () {
      localStorage.setItem('terminalId', this.form.inputCode)
      localStorage.setItem('domainName', this.form.domainName)
    },
    sidebarOpen () {
      this.sidebarShow = true
    },
    sidebarClose () {
      this.sidebarShow = false
    },
    sidebarToggle () {
      if (this.sidebarShow) {
        this.sidebarClose()
      } else {
        this.sidebarOpen()
      }
    },
    handleChannelMessage (event) {
      // hault the previous tab
      if (event.data === 'second tab') {
        this.secondaryTab = true
      }
    },
    useHere () {
      this.secondaryTabChannel.postMessage('second tab')
      // location.reload();
    },
    clearNum () {
      this.form.inputCode = ''
    },
    datachannelmessage (message) {
      console.log('datachannelmessage')
      console.log(JSON.parse(message.data))
      const channelData = JSON.parse(message.data)

      // Ignore heartbeat messages
      if (channelData.type === 'heartbeat') {
        console.log('Heartbeat received')
        return
      }

      if (channelData.terminalId) {
        this.$store.dispatch('setTerminalId', channelData.terminalId)
      } else if (channelData.isSale) {
        const channelData = JSON.parse(message.data)
        this.$store.dispatch('setSaleDetails', channelData.sale.sale)
        this.$store.dispatch('setIsSale', channelData.isSale)
      } else if (channelData.order) {
        this.$store.dispatch('setOrder', channelData.order)
        console.log(channelData.cd_is_open)
        this.$store.dispatch('setIsSale', channelData.isSale)
        this.$store.dispatch('setCdIsOpen', channelData.cd_is_open)
      }
    },
    showAlert (connected = true, $message) {
      if (connected) {
        this.alertModal.title = 'Success'
        this.alertModal.message = $message || 'You are connected!'
        setTimeout(() => {
          this.alertModal.show = false
        }, 5000)
      } else {
        this.alertModal.title = 'Error'
        this.alertModal.message = $message || 'Unable to connect, please try again.'
      }
      this.alertModal.show = true
    },
    showKeyModals () {
      window.addEventListener('keydown', this.onKey)
      this.modalShow = true
    },
    onKey (event) {
      if (!this.isDomainFocused && !this.isTerminalFocused) {
        if (event.keyCode >= 48 && event.keyCode <= 57) {
          this.typeCode(event.keyCode - 48)
        } else if (event.keyCode === 8) {
          this.clearCode()
        }
      }
    },
    clearCode () {
      this.form.inputCode = this.form.inputCode.slice(0, -1)
    },
    async typeCode (num) {
      console.log(num)
      this.form.inputCode = this.form.inputCode.concat(num)
    },
    toggleReverseSidebar () {
      this.$store.dispatch('setReverseSidebar', !this.reverseSidebar)
    },
    toggleFullscreen () {
      this.$store.dispatch('setFullscreen', !this.fullscreen)
    }
  }
}
</script>
<style lang="scss">
.custom-disabled-input:disabled {
  background-color: white !important;
  color: black !important;
  opacity: 1 !important;
}
</style>



// WEBPACK FOOTER //
// src/layouts/CdLayout.vue